import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { AppConfig } from '../../app.config';

@Injectable()
export class CanRegisterService implements CanActivate {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.allowRegister();
  }

  allowRegister(): boolean {
    return AppConfig.canRegister;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/guards/can-register.service.ts